export const iconFontAwesomeGamingHatWizard = (
	<i className="fa-solid fa-hat-wizard"></i>
);
